import { Trans } from "@lingui/macro"
import { Typography, Box, Divider, Select, MenuItem, Button } from "@mui/material"
import React from "react"
import { useNavigate } from "react-router-dom"

import ProjectCollections from "../../components/modules/nftLaunchpad/ProjectCollections"
import { useNFTs } from "../../contexts/NFTsContext"
import { useProjectApi } from "../../contexts/ProjectContext"
import { ROUTE_LINKS } from "../../routes/routes"

const NFTsProjectPage = (): JSX.Element | null => {
  const { projects } = useProjectApi()
  const { NFTsProject } = useNFTs()
  const navigate = useNavigate()

  if (!NFTsProject) return null

  return (
    <Box pt={1} pb={1}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          ml: 2,
          mr: 2,
        }}
      >
        <Box display="flex" alignItems="center" mb={0.5}>
          <Typography sx={{ flex: 1, color: "#F5F5F5", fontWeight: 500 }} variant="h4">
            <Trans>NFT Launchpad</Trans>
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <Select
            size="small"
            sx={{ background: "#333333", height: "36px", width: "160px" }}
            value={NFTsProject.projectId}
            onChange={(e) => {
              navigate(ROUTE_LINKS.NFTsOnProject(e.target.value))
            }}
            data-cy="dropdown-nft-launchpad-change-project"
          >
            {projects?.map((p) => (
              <MenuItem key={p.name} value={p.projectId}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
          <Button
            onClick={() => {
              navigate(ROUTE_LINKS.NFTsCollectionNewCreate(NFTsProject.projectId || ""))
            }}
            sx={{
              background: "#333333",
              pl: 2,
              pr: 2,
              ":hover": {
                background: "#333333",
              },
            }}
            data-cy="button-nft-launchpad-new-collection"
          >
            <Trans>New Collection</Trans>
          </Button>
        </Box>
      </Box>
      <Divider sx={{ mt: 2, mb: 2 }} />
      <Box mb={4}>
        <ProjectCollections />
      </Box>
    </Box>
  )
}

export default NFTsProjectPage
